/* generated by pull.js */
const manifest = {
  editorOnly: true,
  noTranslations: true,
  name: 'Always show number pad',
  description:
    "Show Scratch's virtual number pad when editing number fields in blocks on all devices, instead of only touchscreen devices.",
  credits: [
    {
      name: 'GarboMuffin'
    }
  ],
  info: [
    {
      text: 'A number pad will show when editing number inputs from blocks such as "move () steps".',
      id: 'explanation'
    }
  ],
  tags: [],
  userscripts: [
    {
      url: 'userscript.js'
    }
  ],
  dynamicDisable: true
};
export default manifest;
